// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"94":"2ff5d8814e4a5b066069","385":"c2155a7818af4a1f6406","644":"22e0cf8e3845bae6f3b3","994":"a99bc897728e1969dfa5"}[chunkId] + ".css";
};